import imgApi from './images';
const imgData = [
  {
    img: imgApi[3],
    thumb: imgApi[3],
    title: 'Breakfast',
    author: 'jill111',
    cols: 2,
    featured: true,
  },
  {
    img: imgApi[5],
    thumb: imgApi[5],
    title: 'Tasty burger',
    author: 'director90',
  },
  {
    img: imgApi[33],
    thumb: imgApi[33],
    title: 'Camera',
    author: 'Danson67',
  },
  {
    img: imgApi[35],
    thumb: imgApi[35],
    title: 'Morning',
    author: 'fancycrave1',
    featured: true,
  },
  {
    img: imgApi[41],
    thumb: imgApi[41],
    title: 'Hats',
    author: 'Hans',
  },
  {
    img: imgApi[43],
    thumb: imgApi[43],
    title: 'Honey',
    author: 'fancycravel',
  },
  {
    img: imgApi[7],
    thumb: imgApi[7],
    title: 'Vegetables',
    author: 'jill111',
    cols: 2,
  },
  {
    img: imgApi[9],
    thumb: imgApi[9],
    title: 'Water plant',
    author: 'BkrmadtyaKarki',
  },
  {
    img: imgApi[17],
    thumb: imgApi[17],
    title: 'Mushrooms',
    author: 'PublicDomainPictures',
  },
  {
    img: imgApi[13],
    thumb: imgApi[13],
    title: 'Olive oil',
    author: 'congerdesign',
  },
  {
    img: imgApi[19],
    thumb: imgApi[19],
    title: 'Sea star',
    cols: 2,
    author: '821292',
  },
  {
    img: imgApi[47],
    thumb: imgApi[47],
    title: 'Bike',
    author: 'danfador',
  },
];

export default imgData;
